import * as React from 'react';
import { useState } from 'react';
import AuthLayout from '../../components/AuthLayout';
import { TextInput } from '../../components/fields/TextInput';
import { useRouter } from 'next/router';
import sendSignInLinkToEmail from '../../helpers/auth/sendSignInLinkToEmail';

type Props = {};

export default function LoginPage({}: Props) {
  const [email, setEmail] = useState('');
  const router = useRouter();
  const agentSlug = router.query.agentSlug as string;

  return (
    <AuthLayout
      title={'Login to account'}
      subtitle={
        "Don't have an account? Create one by entering your email below:"
      }
    >
      <form id={'email-form'}>
        <div className="space-y-6">
          <TextInput
            label="Email address"
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={e => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <button
          type="submit"
          disabled={!email}
          className="btn mt-8 w-full"
          onClick={async e => {
            e.preventDefault();
            await sendSignInLinkToEmail(email, agentSlug);
            router.push({
              pathname: '/auth/check-email',
              query: { email },
            });
          }}
        >
          Continue
        </button>
      </form>
    </AuthLayout>
  );
}
